var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,29H2c-0.5527344,0-1-0.4477539-1-1V4c0-0.5522461,0.4472656-1,1-1h28c0.5527344,0,1,0.4477539,1,1v24C31,28.5522461,30.5527344,29,30,29z M3,27h26V5H3V27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,15h-6.78125c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1H25c0.5527344,0,1,0.4477539,1,1S25.5527344,15,25,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.609375,19H18.21875c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h3.390625c0.5527344,0,1,0.4477539,1,1S22.1621094,19,21.609375,19z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6315794,
    cy: 12.5263157,
    r: 2.5263157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.975728,22H8.2874298C7.5764017,22,7,21.4235973,7,20.7125702v-0.0000057c0-2.5579472,2.0736265-4.6315746,4.6315746-4.6315746h0.0000086c2.5579481,0,4.6315756,2.0736275,4.6315756,4.6315746v0.0000057C16.2631588,21.4235973,15.6867561,22,14.975728,22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardIcon);
export default __webpack_public_path__ + "static/media/id-card-icon.4c8af3ca96ac62830bfaa37a58518e25.svg";
export { ForwardRef as ReactComponent };